import type {Appraisal} from '~/types/domain/Appraisals';

export function mostRelevantSorting(appraisals: Appraisal[]): Appraisal[] {
    return appraisals.sort((a: Appraisal, b: Appraisal) => {
        const aHasComment = !!a.comment;
        const bHasComment = !!b.comment;

        if (aHasComment !== bHasComment) {
            return aHasComment ? -1 : 1;
        }

        return new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime();
    });
}

export function bestRatingSorting(appraisals: Appraisal[]): Appraisal[] {
    return appraisals.sort((a: Appraisal, b: Appraisal) => {
        if (a.generalRating !== b.generalRating) {
            return (b.generalRating ?? 0) - (a.generalRating ?? 0);
        }
        return new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime();
    });
}

export function mostRecentSorting(appraisals: Appraisal[]): Appraisal[] {
    return appraisals.sort((a: Appraisal, b: Appraisal) => {
        return new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime();
    });
}

export function clientFirstSorting(appraisals: Appraisal[], connectedAccountId?: string): Appraisal[] {
    return appraisals.sort((a: Appraisal, b: Appraisal) => {
        const aIsClient = a.clientAccountId === connectedAccountId ? -1 : 1;
        const bIsClient = b.clientAccountId === connectedAccountId ? -1 : 1;
        return aIsClient - bIsClient;
    });
}
